import { useAuthStore } from '../../stores/auth';

/** Mirrors the API's redaction set (apps/api/src/auth/redact.ts, #171). */
const INTERNAL_FIELDS: ReadonlySet<string> = new Set(['source_id']);

/** Drop internal fields from a field list unless the viewer is an admin. */
export function visibleFields<T extends string>(
  fields: readonly T[],
  isAdmin: boolean,
): readonly T[] {
  return isAdmin ? fields : fields.filter((f) => !INTERNAL_FIELDS.has(f));
}

export const useIsAdmin = (): boolean => useAuthStore((s) => s.me?.role === 'admin');
